import apiConfig from '@/config/apiConfig';
import { apiBaseURL, toastifyType } from '@/constants';
import { addTost } from './toastAction';

export const getAllAnnotationSpaces = ({ setLoading }) => async (dispatch) => {
    setLoading && setLoading(true)
    try {
        let url = `${apiBaseURL.ANNOTATIONS}/spaces/all`

        const response = await apiConfig.get(url);
        setLoading && setLoading(false);
        return response
    } catch (error) {
        setLoading && setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const addUpdateAnnotationSpace = ({ payload, setLoading }) => async (dispatch) => {
    setLoading && setLoading(true)
    try {
        let url = `${apiBaseURL.ANNOTATIONS}/spaces/add-update`

        const response = await apiConfig.post(url, payload);
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        setLoading && setLoading(false);
        return response
    } catch (error) {
        setLoading && setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const deleteAnnotationSpace = ({ deleteSpaceId, setLoading }) => async (dispatch) => {
    setLoading && setLoading(true)
    try {
        let url = `${apiBaseURL.ANNOTATIONS}/spaces/${deleteSpaceId}`;

        const response = await apiConfig.delete(url, deleteSpaceId);
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        setLoading && setLoading(false);
        return response
    } catch (error) {
        setLoading && setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
};

export const addMembersToSpace = ({ payload, setLoading }) => async (dispatch) => {
    try {
        setLoading && setLoading(true)
        let url = `${apiBaseURL.ANNOTATIONS}/spaces/add-member`;
        const response = await apiConfig.post(url, payload);
        setLoading && setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        return response;

    } catch (error) {
        setLoading && setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
        console.log(error);
    }
};
export const searchUsersFromSpace = ({ payload, setLoading }) => async (dispatch) => {
    try {
        setLoading && setLoading(true)
        let url = `/user/search-users`;

        if (payload?.name) {
            url = `${url}?name=${payload.name}`
        }
        const response = await apiConfig.get(url);
        setLoading && setLoading(false)
        // dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        return response;

    } catch (error) {
        setLoading && setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
        console.log(error);
    }
};

export const getMembersOfSpace = ({ spaceId, setLoading }) => async (dispatch) => {
    try {
        setLoading && setLoading(true)
        const url = `${apiBaseURL.ANNOTATIONS}/spaces/${spaceId}/members`;
        const response = await apiConfig.get(url);

        setLoading && setLoading(false)
        return response;

    } catch (error) {
        setLoading && setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
        console.log(error);
    }
};

export const spaceMemberRoleChange = ({ payload, setLoading }) => async (dispatch) => {
    try {
        setLoading && setLoading(true)
        const url = `${apiBaseURL.ANNOTATIONS}/spaces/member-role-change`;
        const response = await apiConfig.post(url, payload);

        setLoading && setLoading(false)
        return response;

    } catch (error) {
        setLoading && setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
        console.log(error);
    }
};

export const removeMemberFromSpace = ({ memberId, setLoading }) => async (dispatch) => {
    try {
        setLoading && setLoading(true)

        const url = `${apiBaseURL.ANNOTATIONS}/spaces/member/${memberId}`;

        const response = await apiConfig.delete(url);
        setLoading && setLoading(false)
        response?.data?.success && dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))

        return response;

    } catch (error) {
        setLoading && setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
        console.log(error);
    }
}

export const exitFromCurrentAnnotationSpace = ({ spaceId, setLoading }) => async (dispatch) => {
    try {
        setLoading && setLoading(true)
        const url = `${apiBaseURL.ANNOTATIONS}/spaces/${spaceId}/exit`;
        const response = await apiConfig.get(url);
        setLoading && setLoading(false)
        return response;

    } catch (error) {
        setLoading && setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
        console.log(error);
    }
}

export const handleSaveArticleToSpaces = ({ setLoading, payload }) => async (dispatch) => {
    setLoading && setLoading(true)
    try {
        const response = await apiConfig.post(`${apiBaseURL.FEEDS}/share-articles`, payload);
        setLoading && setLoading(false);
        return response
    } catch (error) {
        setLoading && setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
};

export const removeArticleFromSpaces = ({ setLoading, payload }) => async (dispatch) => {
    setLoading && setLoading(true)
    try {
        const response = await apiConfig.post(`${apiBaseURL.FEEDS}/share-articles`, payload);
        setLoading && setLoading(false);
        return response
    } catch (error) {
        setLoading && setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
};